import { atom } from "jotai";
import type { ClaraEntryPoint } from "../constants/clara-entry-point.enum";

export const claraEntryPointAtom = atom<ClaraEntryPoint | undefined>(undefined);
